module.exports = __webpack_public_path__ + "img/baidu.21f3ddbc.webp";